// Service du tournoi en salle (room-games). Instance axios à part : pas de signature SigV4 (les routes de l'arbitre
// passent par le jeton d'identité Cognito, celles des joueurs par leur jeton, l'écran par sa clé).
import axios from 'axios';
import iam from '../iam';
import { sample } from './clock';

const http = axios.create({ timeout: 15000 });
http.interceptors.request.use((config) => {
  config.sentAt = Date.now();
  return config;
});
http.interceptors.response.use((response) => {
  sample({ serverTime: response.data && response.data.serverTime, sentAt: response.config.sentAt, receivedAt: Date.now() });
  return response;
});

const base = () => `${import.meta.env.VITE_ROOM_API_URL || import.meta.env.VITE_LCT_API_URL}/room-games`;
const player = token => ({ headers: { Authorization: `Bearer ${token}` } });
const data = response => response.data;

// Routes de l'arbitre : jeton d'identité Cognito ; s'il est absent ou expiré (401), il est renouvelé une fois
const referee = (send) => {
  const attempt = () => send({ headers: { Authorization: `Bearer ${sessionStorage.getItem('id_token')}` } });
  return attempt().catch((error) => {
    if (!error.response || error.response.status !== 401) {
      throw error;
    }
    return iam.refreshRole().then(attempt);
  }).then(data);
};

export default {
  createGame: body => referee(config => http.post(base(), body, config)),
  listGames: () => referee(config => http.get(base(), config)),
  getGame: (id, round) => referee(config => http.get(`${base()}/${id}`, { ...config, params: round ? { round } : undefined })),
  act: (id, body) => referee(config => http.post(`${base()}/${id}/actions`, body, config)),
  join: (code, name) => http.post(`${base()}/join`, { code, name }).then(data),
  playerState: (id, token) => http.get(`${base()}/${id}/player`, player(token)).then(data),
  saveEntry: (id, token, entry) => http.put(`${base()}/${id}/entry`, entry, player(token)).then(data),
  screenState: (id, key) => http.get(`${base()}/${id}/screen`, { params: { key } }).then(data),
};

export function errorMessage(error) {
  const body = error && error.response && error.response.data;
  return (body && body.message) || 'Connexion au serveur impossible : réessayez.';
}

export function errorStatus(error) {
  return error && error.response ? error.response.status : undefined;
}
